import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import MenuCard from "./MenuCard.jsx";
import api from "../../utils/api.js";
import { MdInfoOutline } from "react-icons/md";
import Cookies from "js-cookie"
import { Tooltip } from "react-tooltip";
function MenuCardSection({
  title,
  searchTerm,
  selectedDietOption,
  activeCategoryId,
  allCategory
}) {
  console.log("🚀 ~ allCategory:", allCategory)
  const [allProducts, setAllProducts] = useState([]); // All data from server
  const [filteredProducts, setFilteredProducts] = useState([]); // Filtered data
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await api.get(`/menu-food?limit=500`);
        setAllProducts(data.data.results);
        setFilteredProducts(data.data.results);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  // Filter by category or search term or diet option
  useEffect(() => {
    let filtered = allProducts;
  
    // Ensure no products are displayed if no category is selected
    if (!activeCategoryId) {
      filtered = [];
    } else {
      filtered = filtered.filter(
        (item) => item.categoryId === activeCategoryId
      );
    }
  
    if (selectedDietOption) {
      filtered = filtered.filter((item) => item.type === selectedDietOption);
    }
  
    if (searchTerm) {
      filtered = filtered.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
  
    setFilteredProducts(filtered);
    setCurrentPage(1); // Reset to first page
  }, [activeCategoryId, searchTerm, selectedDietOption, allProducts]);
  
  // Paginate data
  const paginatedProducts = filteredProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const handlePageChange = (direction) => {
    setCurrentPage((prev) =>
      direction === "next"
        ? Math.min(prev + 1, totalPages)
        : Math.max(prev - 1, 1)
    );
  };
  const RestaurantSavedId =  JSON.parse(localStorage.getItem('selectedRestaurantId'))
const restaurantStatus = Cookies.get(`restaurantStatus_${RestaurantSavedId}`)


  return (
    <div>
      {paginatedProducts.length > 0 && (
        <div className="mb-6">
          <div className="flex justify-between items-center px-4 pb-4 mt-4">
            <h1 className="heading font-bold lg:text-[34.92px] sm:text-[22px] text-[22px] text-[#AF313D]  capitalize">
              {title} 

            </h1>
            <div className=" flex justify-end items-end mx-3">
              <p 
            
                className={`${
                  restaurantStatus === "open" ? "text-[#AD343E] " : "bg-red-100 text-red-500"
                } p-2 px-4 rounded-full font-semibold flex gap-2 items-center`}
              >
                {restaurantStatus === "open" ? "open" : "closed"}<MdInfoOutline
                className=" cursor-pointer my-tooltip"
                data-tooltip-id="my-tooltip" data-tooltip-content={restaurantStatus === 'open' 
                  ? "Restaurants Is Open" 
                  : "Closed"}
                />
              </p>
               <Tooltip  id="my-tooltip" />
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-4 gap-5 mb-4 px-4">
            {paginatedProducts.map((item, index) => (
              <div key={index} className="flex flex-col">
                <MenuCard item={item} allProducts={allProducts} allCategory={allCategory} />
              </div>
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-between items-center px-4">
              <button
                onClick={() => handlePageChange("prev")}
                disabled={currentPage === 1}
                className="p-2 hover:bg-gray-300 rounded-r-lg"
              >
                <FaArrowLeft />
              </button>

              <button
                onClick={() => handlePageChange("next")}
                disabled={currentPage === totalPages}
                className="p-2 hover:bg-gray-300 rounded-r-lg"
              >
                <FaArrowRight />
              </button>
            </div>
          )}
        </div>
      )}

      {!paginatedProducts.length && (
        <h1 className="text-center w-full pb-[100px] text-[20px]">
          No products found!
        </h1>
      )}
    </div>
  );
}

export default MenuCardSection;
